module.exports = __webpack_public_path__ + "static/media/Location_Icon.9166809f.svg";